import { Box, Img } from "@chakra-ui/react";
import React from "react";
import logo from "../assets/logo_2_2_cpk7a0.png"

export const Logo = ({ color }) => {
    return (
        <Box>
            <Img
                p="12px"
                maxH={{ base: "42px", sm: "60px" }}
                minH={{ base: "42px", md: "60px" }}
                src={logo}
            />
        </Box>
    );
};
